import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { AuthProvider } from "./context/auth";
import { UnitsProvider } from "./context/units";
import { Toaster } from "react-hot-toast";

export default function App() {
  return (
    <>
      <AuthProvider>
        <UnitsProvider>
          <RouterProvider router={router} />
        </UnitsProvider>
        <div className="relative">
          <Toaster
            containerStyle={{ zIndex: 9999 }}
            toastOptions={{
              position: "top-right",
              success: {
                style: {
                  background: "#73c2b0",
                  color: "white",
                },
                iconTheme: {
                  primary: "white",
                  secondary: "#73c2b0",
                },
              },
              error: {
                style: {
                  background: "#df6999",
                  color: "white",
                },
                iconTheme: {
                  primary: "white",
                  secondary: "#df6999",
                },
              },
            }}
            gutter={15}
          />
        </div>
      </AuthProvider>
    </>
  );
}
